export default {"src":"/_next/static/media/declic_soft_skills.8fac2685.svg","height":843,"width":842};